// extracted by mini-css-extract-plugin
export default {"about":"About_about__Vucop","container":"About_container__ZkZKY","word":"About_word__TGhx3","hovered":"About_hovered__0aDwJ"};